module.exports = __webpack_public_path__ + "static/media/satan.a6f047b1.gif";